import { classNames, getLHCColor } from "../../../../../tool";
import Number from "../../../../../components/number";
import styles from "../index.module.scss";
export default function TM(props) {
  const { plays, selectPlays, onBet, playOddInfo, firstPlay, secondPlay } =
    props;
  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const active =
          selectPlays.findIndex((i) => i.code === item.code) !== -1;
        const color = getLHCColor(item.name);
        return (
          <div
            key={index}
            className={classNames(
              styles.TM,
              styles.playItem,
              active ? styles.active : "",
              styles[color]
            )}
            onClick={() => onBet(item)}
          >
            <Number
              active={active}
              number={item.name}
              width={"9.689rem"}
              height={"9.689rem"}
            />
            <div
              className={classNames(
                styles.odds,
                item.minOdds ? styles.minOdds : ""
              )}
            >
              {item.minOdds
                ? `${
                    playOddInfo[
                      `LHC_${firstPlay.code}_${
                        secondPlay.code || firstPlay.code
                      }${item.code}0`
                    ]
                  }/`
                : ""}
              {
                playOddInfo[
                  `LHC_${firstPlay.code}_${secondPlay.code || firstPlay.code}${
                    item.code
                  }`
                ]
              }
            </div>
          </div>
        );
      })}
    </div>
  );
}
